export class ExceptionSubCategoriesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  #buildQueryString({ category }) {
    const params = new URLSearchParams();

    if (category) {
      params.append('category', category);
    }

    const query = params.toString();

    return query ? `?${query}` : '';
  }

  async getExceptionSubCategories({ category } = {}) {
    const queryString = this.#buildQueryString({ category });

    return this.#http.get(`/exceptionSubCategories${queryString}`);
  }

  async createExceptionSubCategory(args) {
    return this.#http.post('/exceptionSubCategories', args);
  }

  async editExceptionSubCategory({ id, ...args }) {
    return this.#http.put(`/exceptionSubCategories/${id}`, args);
  }

  async deleteExceptionSubCategory({ id }) {
    return this.#http.delete(`/exceptionSubCategories/${id}`);
  }
}
